<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="名称"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('47')"
        >添加</el-button
      >
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态" sortable="status">
          <template #default="{ row }">
            <text :style="{ color: row.status == 1 ? '#1e90ff' : '#f00' }">{{
              row.status == 1 ? "正常" : "停用"
            }}</text>
          </template>
        </el-table-column>
        <el-table-column label="账户类型">
          <template #default="{ row }">
            <text :style="{ color: row.type == 0 ? '#1e90ff' : '#ffa500' }">{{
              row.type == 0 ? "公司账户" : "个人账户"
            }}</text>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="户名" />
        <el-table-column prop="bank" label="银行" />
        <el-table-column prop="opening_bank" label="开户行" />
        <el-table-column prop="bank_account" label="账号" />
        <el-table-column prop="d_invoice_name" label="发票类型" />
        <el-table-column prop="d_invoice_type_name" label="开票方式" />
        <el-table-column prop="invoice_title" label="开票抬头" />
        <el-table-column
          prop="unified_social_credit_identifier"
          label="统一社会信用代码"
        />
        <el-table-column
          label="操作"
          width="220"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth('47')"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showInfo"
      :title="(state.selectId ? '修改' : '添加') + '子账户'"
      @close="state.showInfo = false"
    >
      <c_Info
        @close="
          state.showInfo = false;
          onLoad();
        "
        :id="state.selectId"
        :customer_id="props.customer_id"
      ></c_Info>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  customermine_subaccount_list,
  customermine_subaccount_delete,
} from "@/http/customer";
import { confirm_func } from "@/utils/qFormat";

import c_Info from "./Info.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  components: {
    c_Info,
  },
  props: {
    customer_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.customer_id = props.customer_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      customermine_subaccount_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.Order = column.sortable;
        state.params.Asc = column.order === "ascending";
      } else {
        const params = new InitFormData().params;
        state.params.Order = params.Order;
        state.params.Asc = params.Asc;
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(customermine_subaccount_delete, id, onLoad);
    };

    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
    };
  },
};
</script>
<style scoped></style>
